import React from "react";
import { useNavigate } from "react-router-dom";
import { SubNavigation } from "@/components/pages/reservations/components/SubNavigation";

interface ReservationNavigationProps {
  activeTab: "customization" | "dashboard";
}

export const SettingsNavigation: React.FC<ReservationNavigationProps> = ({
  activeTab,
}) => {
  const navigate = useNavigate();

  const navigationItems = [
    {
      label: "Customization settings",
      path: "/mobile-settings",
      id: "customization",
    },
    {
      label: "Dashboard settings",
      path: "/mobile-settings/dashboard",
      id: "dashboard",
    },
  ];

  const handleTabChange = (tabId: string) => {
    const item = navigationItems.find((item) => item.id === tabId);
    if (item) {
      navigate(item.path);
    }
  };

  return (
    <SubNavigation
      activeTab={activeTab}
      onTabChange={handleTabChange}
      tabs={navigationItems}
    />
  );
};
